"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocaleManager = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var DEFAULT_LOCALE = 'common';

var LocaleManager = /*#__PURE__*/function () {
  function LocaleManager() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        locale = _ref.locale,
        languages = _ref.languages;

    _classCallCheck(this, LocaleManager);

    this._transformLanguages(languages || {});

    this.setLocale(locale);
  }

  _createClass(LocaleManager, [{
    key: "setLocale",
    value: function setLocale(locale) {
      this.locale = locale;

      this._resolveLanguage(locale || '');
    }
  }, {
    key: "getLanguage",
    value: function getLanguage() {
      return this.language;
    }
  }, {
    key: "_transformLanguages",
    value: function _transformLanguages(languages) {
      var _this = this;

      this.languages = {};
      Object.keys(languages).map(function (locale) {
        _this.languages[locale.trim().toLowerCase()] = languages[locale];
      });
    }
  }, {
    key: "_resolveLanguage",
    value: function _resolveLanguage(locale) {
      this.language = _objectSpread({}, this.languages[DEFAULT_LOCALE] || {});
      var parts = locale.trim().toLowerCase().split('-');

      for (var i = 0; i <= parts.length; i++) {
        var _locale = parts.slice(0, i).join('-');

        if (_locale && _locale !== '') {
          this.language = _objectSpread({}, this.language, {}, this.languages[_locale] || {});
        }
      }
    }
  }]);

  return LocaleManager;
}();

exports.LocaleManager = LocaleManager;